/* nplus-leasing-deposit-service.js — endpoint resolution + combined inquiry-with-deposit call.
   Classic script: exposes window.nplusLeasingDeposit. No dependencies. */
(function () {
  'use strict';

  function resolveEndpoint() {
    var host = window.location.hostname;
    var isLocal = host === 'localhost' || host === '127.0.0.1';
    if (isLocal && window.__BACKEND_BASE) {
      return window.__BACKEND_BASE.replace(/\/$/, '') + '/create-leasing-deposit';
    }
    return '/apps/nplus-deposit/create-leasing-deposit';
  }

  function createInquiryWithDeposit(payload) {
    return fetch(resolveEndpoint(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) {
      return r.json().then(function (body) {
        if (!r.ok) throw new Error(body && body.error ? body.error : 'leasing deposit request failed');
        return body; // { clientSecret, customerId } — the draft order is created after payment succeeds
      });
    });
  }

  window.nplusLeasingDeposit = { resolveEndpoint: resolveEndpoint, createInquiryWithDeposit: createInquiryWithDeposit };
})();
